// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jzon from "rescript-jzon/lib/es6/src/Jzon.res.js";
import * as LumiSVG from "lumi-rescript/lib/es6/src/LumiSVG.res.js";
import * as LumiSet from "lumi-rescript/lib/es6/src/LumiSet.res.js";
import * as Belt_Set from "@rescript/runtime/lib/es6/Belt_Set.js";
import * as LumiJzon from "lumi-rescript/lib/es6/src/LumiJzon.res.js";
import * as LumiArray from "lumi-array/lib/es6/src/LumiArray.res.js";
import * as LumiReact from "lumi-rescript/lib/es6/src/LumiReact.res.js";
import * as V2$Linear from "lumi-linear/lib/es6/src/V2.res.js";
import * as LumiOption from "lumi-rescript/lib/es6/src/LumiOption.res.js";
import * as V2i$Linear from "lumi-linear/lib/es6/src/V2i.res.js";
import * as Rect$Linear from "lumi-linear/lib/es6/src/Rect.res.js";
import * as StringCodec from "lumi-rescript/lib/es6/src/StringCodec.res.js";
import * as Rectf$Linear from "lumi-linear/lib/es6/src/Rectf.res.js";
import * as Recti$Linear from "lumi-linear/lib/es6/src/Recti.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Stdlib_Result from "@rescript/runtime/lib/es6/Stdlib_Result.js";
import * as Belt_MapString from "@rescript/runtime/lib/es6/Belt_MapString.js";
import * as FontAwesome$Web from "lumi-web/lib/es6/src/FontAwesome.res.js";
import * as LumiDrawCommand from "lumi-draw-command/lib/es6/src/LumiDrawCommand.res.js";
import * as LumiGeolocation from "lumi-rescript/lib/es6/src/LumiGeolocation.res.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as Schema$LumiStore from "lumi-store/lib/es6/src/Schema.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Document$LumiStore from "lumi-store/lib/es6/src/Document.res.js";
import * as Types$LumiDocuments from "./Types.res.js";
import * as SignSettings$LumiDocuments from "./SignSettings.res.js";
import * as SensorGroups$LumiStaticData from "lumi-static-data/lib/es6/src/SensorGroups.res.js";

let jsonCodec = LumiJzon.taggedVariantOptionalContents(v => {
  if (typeof v !== "object") {
    if (v === "DisplayModeAvailabilityColorFreeFull") {
      return [
        "FreeFull",
        undefined
      ];
    } else {
      return [
        "FreeBusyFull",
        undefined
      ];
    }
  } else {
    return [
      "Fixed",
      Jzon.encodeWith(v._0, Types$LumiDocuments.Color.jsonCodec)
    ];
  }
}, pair => {
  let other = pair[0];
  switch (other) {
    case "Fixed" :
      let json = pair[1];
      if (json !== undefined) {
        return Stdlib_Result.map(Jzon.decodeWith(json, Types$LumiDocuments.Color.jsonCodec), color => ({
          TAG: "DisplayModeAvailabilityColorFixed",
          _0: color
        }));
      } else {
        return {
          TAG: "Error",
          _0: {
            NAME: "UnexpectedJsonValue",
            VAL: [
              [],
              other
            ]
          }
        };
      }
    case "FreeBusyFull" :
      return {
        TAG: "Ok",
        _0: "DisplayModeAvailabilityColorFreeBusyFull"
      };
    case "FreeFull" :
      return {
        TAG: "Ok",
        _0: "DisplayModeAvailabilityColorFreeFull"
      };
    default:
      return {
        TAG: "Error",
        _0: {
          NAME: "UnexpectedJsonValue",
          VAL: [
            [],
            other
          ]
        }
      };
  }
}, undefined, undefined);

let DisplayModeAvailabilityColor = {
  jsonCodec: jsonCodec
};

let jsonCodec$1 = LumiJzon.taggedVariantOptionalContents(v => {
  if (typeof v !== "object") {
    return [
      "Number",
      undefined
    ];
  } else {
    return [
      "Text",
      Jzon.encodeWith(v._0, Jzon.string)
    ];
  }
}, pair => {
  let other = pair[0];
  switch (other) {
    case "Number" :
      return {
        TAG: "Ok",
        _0: "DisplayModeFullRepresentationNumber"
      };
    case "Text" :
      let json = pair[1];
      if (json !== undefined) {
        return Stdlib_Result.map(Jzon.decodeWith(json, Jzon.string), text => ({
          TAG: "DisplayModeFullRepresentationText",
          _0: text
        }));
      } else {
        return {
          TAG: "Error",
          _0: {
            NAME: "UnexpectedJsonValue",
            VAL: [
              [],
              other
            ]
          }
        };
      }
    default:
      return {
        TAG: "Error",
        _0: {
          NAME: "UnexpectedJsonValue",
          VAL: [
            [],
            other
          ]
        }
      };
  }
}, undefined, undefined);

let DisplayModeFullRepresentation = {
  jsonCodec: jsonCodec$1
};

let jsonCodec$2 = Jzon.object3(param => [
  param.font,
  param.hAlign,
  param.vAlign
], param => ({
  TAG: "Ok",
  _0: {
    font: param[0],
    hAlign: param[1],
    vAlign: param[2]
  }
}), Jzon.field("font", Jzon.string), Jzon.field("hAlign", LumiDrawCommand.HAlign.jsonCodec), Jzon.field("vAlign", LumiDrawCommand.VAlign.jsonCodec));

let DisplayModeTextOptions = {
  jsonCodec: jsonCodec$2
};

let options = [
  "DisplayModeArrowStyleStraight",
  "DisplayModeArrowStyleAngled"
];

let jsonCodec$3 = LumiJzon.anySumAsString(options, __x => __x.substring("DisplayModeArrowStyle".length));

let DisplayModeArrowStyle = {
  options: options,
  jsonCodec: jsonCodec$3
};

let textCodec = LumiJzon.tuple3(Jzon.string, Types$LumiDocuments.Color.jsonCodec, jsonCodec$2);

let arrowCodec = LumiJzon.tuple3(Types$LumiDocuments.CardinalDirection.jsonCodec, Types$LumiDocuments.Color.jsonCodec, jsonCodec$3);

let jsonCodec$4 = LumiJzon.taggedVariantOptionalContents(v => {
  if (typeof v !== "object") {
    return [
      "Blank",
      undefined
    ];
  }
  switch (v.TAG) {
    case "DisplayModeStaticFloodFill" :
      return [
        "FloodFill",
        Jzon.encodeWith(v._0, Types$LumiDocuments.Color.jsonCodec)
      ];
    case "DisplayModeStaticText" :
      return [
        "Text",
        Jzon.encodeWith([
          v._0,
          v._1,
          v._2
        ], textCodec)
      ];
    case "DisplayModeStaticImage" :
      return [
        "Image",
        Jzon.encodeWith(v._0, Jzon.string)
      ];
    case "DisplayModeStaticArrow" :
      return [
        "Arrow",
        Jzon.encodeWith([
          v._0,
          v._1,
          v._2
        ], arrowCodec)
      ];
  }
}, pair => {
  let other = pair[0];
  switch (other) {
    case "Arrow" :
      let json = pair[1];
      if (json !== undefined) {
        return Stdlib_Result.map(Jzon.decodeWith(json, arrowCodec), param => ({
          TAG: "DisplayModeStaticArrow",
          _0: param[0],
          _1: param[1],
          _2: param[2]
        }));
      }
      break;
    case "Blank" :
      return {
        TAG: "Ok",
        _0: "DisplayModeStaticBlank"
      };
    case "FloodFill" :
      let json$1 = pair[1];
      if (json$1 !== undefined) {
        return Stdlib_Result.map(Jzon.decodeWith(json$1, Types$LumiDocuments.Color.jsonCodec), color => ({
          TAG: "DisplayModeStaticFloodFill",
          _0: color
        }));
      }
      break;
    case "Image" :
      let json$2 = pair[1];
      if (json$2 !== undefined) {
        return Stdlib_Result.map(Jzon.decodeWith(json$2, Jzon.string), path => ({
          TAG: "DisplayModeStaticImage",
          _0: path
        }));
      }
      break;
    case "Text" :
      let json$3 = pair[1];
      if (json$3 !== undefined) {
        return Stdlib_Result.map(Jzon.decodeWith(json$3, textCodec), param => ({
          TAG: "DisplayModeStaticText",
          _0: param[0],
          _1: param[1],
          _2: param[2]
        }));
      }
      break;
  }
  return {
    TAG: "Error",
    _0: {
      NAME: "UnexpectedJsonValue",
      VAL: [
        [],
        other
      ]
    }
  };
}, undefined, undefined);

let DisplayModeStatic = {
  jsonCodec: jsonCodec$4
};

let numFreeCodec = LumiJzon.tuple3(jsonCodec, jsonCodec$1, jsonCodec$2);

let arrowCodec$1 = LumiJzon.tuple2(jsonCodec, jsonCodec$3);

let jsonCodec$5 = LumiJzon.taggedVariant(v => {
  switch (v.TAG) {
    case "DisplayModeGroupNumFree" :
      return [
        "NumFree",
        Jzon.encodeWith([
          v._0,
          v._1,
          v._2
        ], numFreeCodec)
      ];
    case "DisplayModeGroupOpen" :
      return [
        "Open",
        Jzon.encodeWith(v._0, jsonCodec$2)
      ];
    case "DisplayModeGroupFreeFull" :
      return [
        "FreeFull",
        Jzon.encodeWith(v._0, jsonCodec$2)
      ];
    case "DisplayModeGroupFloodFill" :
      return [
        "FloodFill",
        Jzon.encodeWith(v._0, jsonCodec)
      ];
    case "DisplayModeGroupArrow" :
      return [
        "Arrow",
        Jzon.encodeWith([
          v._0,
          v._1
        ], arrowCodec$1)
      ];
    case "DisplayModeGroupAlternative" :
      return [
        "Alternative",
        Jzon.encodeWith(v._0, jsonCodec$2)
      ];
    case "DisplayModeGroupFacilityName" :
      return [
        "FacilityName",
        Jzon.encodeWith(v._0, jsonCodec$2)
      ];
    case "DisplayModeGroupPopUpNum" :
      return [
        "PopUpNum",
        Jzon.encodeWith(v._0, jsonCodec$2)
      ];
  }
}, param => {
  let json = param[1];
  let tag = param[0];
  switch (tag) {
    case "Alternative" :
      return Stdlib_Result.map(Jzon.decodeWith(json, jsonCodec$2), textOptions => ({
        TAG: "DisplayModeGroupAlternative",
        _0: textOptions
      }));
    case "Arrow" :
      return Stdlib_Result.map(Jzon.decodeWith(json, arrowCodec$1), param => ({
        TAG: "DisplayModeGroupArrow",
        _0: param[0],
        _1: param[1]
      }));
    case "FacilityName" :
      return Stdlib_Result.map(Jzon.decodeWith(json, jsonCodec$2), textOptions => ({
        TAG: "DisplayModeGroupFacilityName",
        _0: textOptions
      }));
    case "FloodFill" :
      return Stdlib_Result.map(Jzon.decodeWith(json, jsonCodec), availabilityColor => ({
        TAG: "DisplayModeGroupFloodFill",
        _0: availabilityColor
      }));
    case "FreeFull" :
      return Stdlib_Result.map(Jzon.decodeWith(json, jsonCodec$2), textOptions => ({
        TAG: "DisplayModeGroupFreeFull",
        _0: textOptions
      }));
    case "NumFree" :
      return Stdlib_Result.map(Jzon.decodeWith(json, numFreeCodec), param => ({
        TAG: "DisplayModeGroupNumFree",
        _0: param[0],
        _1: param[1],
        _2: param[2]
      }));
    case "Open" :
      return Stdlib_Result.map(Jzon.decodeWith(json, jsonCodec$2), textOptions => ({
        TAG: "DisplayModeGroupOpen",
        _0: textOptions
      }));
    case "PopUpNum" :
      return Stdlib_Result.map(Jzon.decodeWith(json, jsonCodec$2), textOptions => ({
        TAG: "DisplayModeGroupPopUpNum",
        _0: textOptions
      }));
    default:
      return {
        TAG: "Error",
        _0: {
          NAME: "UnexpectedJsonValue",
          VAL: [
            [],
            tag
          ]
        }
      };
  }
}, undefined, undefined);

let DisplayModeGroup = {
  jsonCodec: jsonCodec$5
};

let jsonCodec$6 = LumiJzon.taggedVariant(v => {
  if (v.TAG === "DisplayModeForGroupStatic") {
    return [
      "Static",
      Jzon.encodeWith(v._0, jsonCodec$4)
    ];
  } else {
    return [
      "Group",
      Jzon.encodeWith(v._0, jsonCodec$5)
    ];
  }
}, param => {
  let json = param[1];
  let tag = param[0];
  switch (tag) {
    case "Group" :
      return Stdlib_Result.map(Jzon.decodeWith(json, jsonCodec$5), groupMode => ({
        TAG: "DisplayModeForGroupGroup",
        _0: groupMode
      }));
    case "Static" :
      return Stdlib_Result.map(Jzon.decodeWith(json, jsonCodec$4), staticMode => ({
        TAG: "DisplayModeForGroupStatic",
        _0: staticMode
      }));
    default:
      return {
        TAG: "Error",
        _0: {
          NAME: "UnexpectedJsonValue",
          VAL: [
            [],
            tag
          ]
        }
      };
  }
}, undefined, undefined);

let DisplayModeForGroup = {
  jsonCodec: jsonCodec$6
};

let jsonCodec$7 = Jzon.object2(param => [
  param.direction,
  param.isPopUp
], param => ({
  TAG: "Ok",
  _0: {
    direction: param[0],
    isPopUp: param[1]
  }
}), Jzon.field("direction", Jzon.nullable(Types$LumiDocuments.CardinalDirection.jsonCodec)), Jzon.field("isPopUp", Jzon.bool));

let DisplayModeGroupOptions = {
  jsonCodec: jsonCodec$7
};

function lazyDisplayModeGroupAlternativesCodec() {
  return Jzon.object5(param => [
    param.referenceGroup,
    param.inputs,
    param.includeFull,
    param.mode,
    param.fallbackMode
  ], param => ({
    TAG: "Ok",
    _0: {
      referenceGroup: param[0],
      inputs: param[1],
      includeFull: param[2],
      mode: param[3],
      fallbackMode: param[4]
    }
  }), Jzon.field("referenceGroup", Jzon.nullable(SensorGroups$LumiStaticData.GroupFullId.jsonCodec)), Jzon.field("inputs", Jzon.array(LumiJzon.tuple2(SensorGroups$LumiStaticData.GroupFullId.jsonCodec, jsonCodec$7))), Jzon.field("includeFull", Jzon.bool), Jzon.field("mode", jsonCodec$6), Jzon.field("fallbackMode", lazyDisplayModeCodec()));
}

function lazyDisplayModeSplitVerticallyCodec() {
  return LumiJzon.tuple3(Jzon.int, lazyDisplayModeCodec(), lazyDisplayModeCodec());
}

function lazyDisplayModeCodec() {
  let groupCodec = LumiJzon.tuple3(SensorGroups$LumiStaticData.GroupFullId.jsonCodec, jsonCodec$7, jsonCodec$5);
  return LumiJzon.taggedVariant(v => {
    switch (v.TAG) {
      case "DisplayModeStatic" :
        return [
          "Static",
          Jzon.encodeWith(v._0, jsonCodec$4)
        ];
      case "DisplayModeGroup" :
        return [
          "Group",
          Jzon.encodeWith([
            v._0,
            v._1,
            v._2
          ], groupCodec)
        ];
      case "DisplayModeFirstAvailableGroup" :
        return [
          "FirstAvailableGroup",
          Jzon.encodeWith(v._0, lazyDisplayModeGroupAlternativesCodec())
        ];
      case "DisplayModeSplitVertically" :
        return [
          "SplitVertically",
          Jzon.encodeWith([
            v._0,
            v._1,
            v._2
          ], lazyDisplayModeSplitVerticallyCodec())
        ];
    }
  }, param => {
    let json = param[1];
    let tag = param[0];
    switch (tag) {
      case "FirstAvailableGroup" :
        return Stdlib_Result.map(Jzon.decodeWith(json, lazyDisplayModeGroupAlternativesCodec()), displayModeGroupAlternatives => ({
          TAG: "DisplayModeFirstAvailableGroup",
          _0: displayModeGroupAlternatives
        }));
      case "Group" :
        return Stdlib_Result.map(Jzon.decodeWith(json, groupCodec), param => ({
          TAG: "DisplayModeGroup",
          _0: param[0],
          _1: param[1],
          _2: param[2]
        }));
      case "SplitVertically" :
        return Stdlib_Result.map(Jzon.decodeWith(json, lazyDisplayModeSplitVerticallyCodec()), param => ({
          TAG: "DisplayModeSplitVertically",
          _0: param[0],
          _1: param[1],
          _2: param[2]
        }));
      case "Static" :
        return Stdlib_Result.map(Jzon.decodeWith(json, jsonCodec$4), staticMode => ({
          TAG: "DisplayModeStatic",
          _0: staticMode
        }));
      default:
        return {
          TAG: "Error",
          _0: {
            NAME: "UnexpectedJsonValue",
            VAL: [
              [],
              tag
            ]
          }
        };
    }
  }, undefined, undefined);
}

function groupAlternativesInputGroup(alternatives) {
  let refs = LumiOption.toArray(alternatives.referenceGroup);
  let inputs = alternatives.inputs.map(param => param[0]);
  return Belt_Set.fromArray(LumiArray.concat([
    refs,
    inputs
  ]), SensorGroups$LumiStaticData.GroupFullId.Cmp);
}

function displayModeInputGroup(displayMode) {
  switch (displayMode.TAG) {
    case "DisplayModeGroup" :
      return Primitive_option.some(LumiSet.singleton(displayMode._0, SensorGroups$LumiStaticData.GroupFullId.Cmp));
    case "DisplayModeFirstAvailableGroup" :
      return Primitive_option.some(groupAlternativesInputGroup(displayMode._0));
    case "DisplayModeStatic" :
    case "DisplayModeSplitVertically" :
      return;
  }
}

let Internal = {
  lazyDisplayModeGroupAlternativesCodec: lazyDisplayModeGroupAlternativesCodec,
  lazyDisplayModeSplitVerticallyCodec: lazyDisplayModeSplitVerticallyCodec,
  lazyDisplayModeCodec: lazyDisplayModeCodec,
  groupAlternativesInputGroup: groupAlternativesInputGroup,
  displayModeInputGroup: displayModeInputGroup
};

let jsonCodec$8 = lazyDisplayModeCodec();

let DisplayMode = {
  jsonCodec: jsonCodec$8
};

let jsonCodec$9 = Jzon.object4(param => [
  param.name,
  param.rect,
  param.mode,
  param.preferredGroupNameLabels
], param => ({
  TAG: "Ok",
  _0: {
    name: param[0],
    rect: param[1],
    mode: param[2],
    preferredGroupNameLabels: param[3]
  }
}), Jzon.field("name", Jzon.string), Jzon.field("rect", Recti$Linear.jsonCodec), Jzon.field("mode", jsonCodec$8), Jzon.field("preferredGroupNameLabels", Jzon.array(Jzon.string)));

function inputGroup(region) {
  return displayModeInputGroup(region.mode);
}

function Display$DisplayRegion$SVG(props) {
  let match = props.region;
  let match$1 = match.rect;
  let match$2 = V2$Linear.map(match$1.pos, x => x.toString());
  let match$3 = V2$Linear.map(match$1.size, x => x.toString());
  return JsxRuntime.jsx("rect", {
    children: JsxRuntime.jsx("title", {
      children: match.name
    }),
    height: match$3[1],
    width: match$3[0],
    fill: "transparent",
    stroke: "pink",
    strokeWidth: "1",
    vectorEffect: "non-scaling-stroke",
    x: match$2[0],
    y: match$2[1]
  });
}

let SVG = {
  make: Display$DisplayRegion$SVG
};

let DisplayRegion = {
  jsonCodec: jsonCodec$9,
  inputGroup: inputGroup,
  SVG: SVG
};

let jsonCodec$10 = Jzon.object2(param => [
  param.key,
  param.driverUrl
], param => ({
  TAG: "Ok",
  _0: {
    key: param[0],
    driverUrl: param[1]
  }
}), Jzon.field("key", Document$LumiStore.Key.jsonCodec()), Jzon.field("driverUrl", Jzon.nullable(Types$LumiDocuments.BaseUrl.jsonCodec)));

let ColorlightController = {
  jsonCodec: jsonCodec$10
};

function Display$DisplayController(props) {
  let displayController = props.displayController;
  let tmp;
  tmp = displayController.TAG === "DisplayControllerLumiSign" ? displayController._0 : "Colorlight";
  return JsxRuntime.jsx("span", {
    children: tmp,
    className: "is-family-monospace"
  });
}

let jsonCodec$11 = LumiJzon.taggedVariant(v => {
  if (v.TAG === "DisplayControllerLumiSign") {
    return [
      "LumiSign",
      Jzon.encodeWith(v._0, Jzon.string)
    ];
  } else {
    return [
      "Colorlight",
      Jzon.encodeWith(v._0, jsonCodec$10)
    ];
  }
}, param => {
  let contents = param[1];
  let tag = param[0];
  switch (tag) {
    case "Colorlight" :
      return Stdlib_Result.map(Jzon.decodeWith(contents, jsonCodec$10), colorlightController => ({
        TAG: "DisplayControllerColorlight",
        _0: colorlightController
      }));
    case "LumiSign" :
      return Stdlib_Result.map(Jzon.decodeWith(contents, Jzon.string), name => ({
        TAG: "DisplayControllerLumiSign",
        _0: name
      }));
    default:
      return {
        TAG: "Error",
        _0: {
          NAME: "UnexpectedJsonValue",
          VAL: [
            [],
            tag
          ]
        }
      };
  }
}, undefined, undefined);

let DisplayController = {
  make: Display$DisplayController,
  jsonCodec: jsonCodec$11
};

let jsonCodec$12 = LumiJzon.taggedVariantOptionalContents(v => {
  if (typeof v !== "object") {
    return [
      "Central",
      undefined
    ];
  } else {
    return [
      "FacilityServer",
      Jzon.encodeWith(v._0, Document$LumiStore.Key.jsonCodec())
    ];
  }
}, pair => {
  let other = pair[0];
  switch (other) {
    case "Central" :
      return {
        TAG: "Ok",
        _0: "DisplayUpdaterLocationCentral"
      };
    case "FacilityServer" :
      let json = pair[1];
      if (json !== undefined) {
        return Stdlib_Result.map(Jzon.decodeWith(json, Document$LumiStore.Key.jsonCodec()), facServerKey => ({
          TAG: "DisplayUpdaterLocationFacilityServer",
          _0: facServerKey
        }));
      } else {
        return {
          TAG: "Error",
          _0: {
            NAME: "UnexpectedJsonValue",
            VAL: [
              [],
              other
            ]
          }
        };
      }
    default:
      return {
        TAG: "Error",
        _0: {
          NAME: "UnexpectedJsonValue",
          VAL: [
            [],
            other
          ]
        }
      };
  }
}, undefined, undefined);

let DisplayUpdaterLocation = {
  jsonCodec: jsonCodec$12
};

let jsonCodec$13 = Jzon.object2(param => [
  param.contents,
  param.driver
], param => ({
  TAG: "Ok",
  _0: {
    contents: param[0],
    driver: param[1]
  }
}), Jzon.field("contents", jsonCodec$12), Jzon.field("driver", jsonCodec$12));

let DisplayUpdater = {
  jsonCodec: jsonCodec$13
};

let options$1 = [
  "DisplayPlanned",
  "DisplayOperational",
  "DisplayArchived"
];

let stringCodec = StringCodec.anySumAsString(options$1, __x => __x.substring("Display".length));

let jsonCodec$14 = LumiJzon.stringCodec(stringCodec);

function Display$DisplayOperationalState(props) {
  let value = props.value;
  let tmp;
  switch (value) {
    case "DisplayPlanned" :
      tmp = JsxRuntime.jsx("span", {
        children: JsxRuntime.jsx(FontAwesome$Web.Solid.make, {
          name: "person-digging"
        }),
        className: "icon has-text-warning"
      });
      break;
    case "DisplayOperational" :
      tmp = null;
      break;
    case "DisplayArchived" :
      tmp = JsxRuntime.jsx("span", {
        children: JsxRuntime.jsx(FontAwesome$Web.Solid.make, {
          name: "broom"
        }),
        className: "icon has-text-grey-light"
      });
      break;
  }
  return JsxRuntime.jsxs("span", {
    children: [
      tmp,
      JsxRuntime.jsx("span", {
        children: stringCodec.toString(value)
      })
    ],
    className: "icon-text"
  });
}

let DisplayOperationalState = {
  options: options$1,
  stringCodec: stringCodec,
  jsonCodec: jsonCodec$14,
  make: Display$DisplayOperationalState
};

let jsonCodec$15 = Jzon.object8(param => [
  param.name,
  param.notes,
  param.geoLocation,
  param.regions,
  param.controller,
  param.updatedBy,
  param.signSettings,
  param.operationalState
], param => ({
  TAG: "Ok",
  _0: {
    name: param[0],
    notes: param[1],
    geoLocation: param[2],
    regions: param[3],
    controller: param[4],
    updatedBy: param[5],
    signSettings: param[6],
    operationalState: param[7]
  }
}), Jzon.field("name", Jzon.string), Jzon.field("notes", Jzon.string), Jzon.field("geoLocation", Jzon.nullable(LumiGeolocation.jsonCodec)), Jzon.field("regions", Jzon.array(jsonCodec$9)), Jzon.field("controller", Jzon.nullable(jsonCodec$11)), Jzon.field("updatedBy", jsonCodec$13), Jzon.field("signSettings", SignSettings$LumiDocuments.SignSettings.jsonCodec), Jzon.field("operationalState", jsonCodec$14));

function regionInputGroupSets(display) {
  return Stdlib_Array.filterMap(display.regions, r => displayModeInputGroup(r.mode));
}

function inputGroupSet(display) {
  return LumiSet.unions(regionInputGroupSets(display), SensorGroups$LumiStaticData.GroupFullId.Cmp);
}

function boundingBox(display) {
  return Recti$Linear.boundingBoxFromPoints(display.regions.flatMap(param => {
    let match = Recti$Linear.bounds(param.rect);
    return [
      match[0],
      match[1]
    ];
  }));
}

function Display$Display$SVG(props) {
  let __classList = props.classList;
  let match = props.display;
  let signSettings = match.signSettings;
  let panels = signSettings.panels;
  let classList = __classList !== undefined ? __classList : [];
  let frame = Stdlib_Option.mapOr(SignSettings$LumiDocuments.SignSettings.panelSize(signSettings), Recti$Linear.zero, panelSize => {
    let h = panelSize[1];
    let w = panelSize[0];
    let __x = Belt_MapString.valuesToArray(panels);
    let __x$1 = [].concat(...__x).map(param => {
      let pos_0 = param.x;
      let pos_1 = param.y;
      let pos = [
        pos_0,
        pos_1
      ];
      let rotSize;
      switch (param.rotation) {
        case "RightAngle_0" :
        case "RightAngle_180" :
          rotSize = panelSize;
          break;
        case "RightAngle_90" :
        case "RightAngle_270" :
          rotSize = [
            h,
            w
          ];
          break;
      }
      return [
        pos,
        V2i$Linear.plus(pos, rotSize)
      ];
    });
    return Recti$Linear.boundingBoxFromPoints([].concat(...__x$1));
  });
  let className = LumiReact.classList(classList);
  let aabb = Rectf$Linear.scaleCenter(Rect$Linear.map(frame, prim => prim), 1.02);
  let match$1 = V2$Linear.map(frame.pos, x => x.toString());
  let match$2 = V2$Linear.map(frame.size, x => x.toString());
  return JsxRuntime.jsxs("svg", {
    children: [
      JsxRuntime.jsx("rect", {
        height: match$2[1],
        width: match$2[0],
        fill: "black",
        stroke: "black",
        strokeWidth: "1",
        vectorEffect: "non-scaling-stroke",
        x: match$1[0],
        y: match$1[1]
      }),
      LumiReact.renderOption(undefined, props.lastUpdate, param => param.this.drawCommands.map((command, idx) => JsxRuntime.jsx(LumiDrawCommand.LumiDrawCommand.SVG.make, {
        command: command
      }, idx.toString()))),
      match.regions.map((region, idx) => JsxRuntime.jsx(Display$DisplayRegion$SVG, {
        region: region
      }, idx.toString()))
    ],
    className: className,
    preserveAspectRatio: "xMidYMid meet",
    viewBox: LumiSVG.ViewBox.Float.fromRect(aabb)
  });
}

let SVG$1 = {
  make: Display$Display$SVG
};

let Display = {
  jsonCodec: jsonCodec$15,
  regionInputGroupSets: regionInputGroupSets,
  inputGroupSet: inputGroupSet,
  boundingBox: boundingBox,
  SVG: SVG$1
};

function documentName(param) {
  return param.name;
}

let Schema = Schema$LumiStore.Make({
  documentName: documentName,
  tag: "display",
  jsonCodec: jsonCodec$15,
  icon: "sign",
  readOnly: false
});

let GroupFullId;

export {
  GroupFullId,
  DisplayModeAvailabilityColor,
  DisplayModeFullRepresentation,
  DisplayModeTextOptions,
  DisplayModeArrowStyle,
  DisplayModeStatic,
  DisplayModeGroup,
  DisplayModeForGroup,
  DisplayModeGroupOptions,
  Internal,
  DisplayMode,
  DisplayRegion,
  ColorlightController,
  DisplayController,
  DisplayUpdaterLocation,
  DisplayUpdater,
  DisplayOperationalState,
  Display,
  Schema,
}
/* jsonCodec Not a pure module */
